module.exports = __webpack_public_path__ + "img/export.21d1191d.svg";